import React, { Component } from 'react'
import { Form } from "react-bootstrap-v5";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import * as JobOptions from '../../../../Function/defaultJobOptions'
import EnquiryService from "../../../../Services/EnquiryService";
import csc from "country-state-city";
import helperFunction from '../../../../Function/helperFunction';

class Customerinfo extends Component {
    constructor() {
        super()
        this.state = {
            country : csc.getAllCountries(),
            countryCode : "",
            cities : [],
            states : [],
        }
    }

    validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    checkUser = (e) => {
        let email = e.target.value
        let params = {
            user_email: email.toLowerCase()
        }
        this.validateEmail(email) && EnquiryService.checkEmailApi(params).then((result) => {
            if (result.status === true) {
                if(result.data.length > 0){
                    let custData = result.data[0]
                    // let contactNum = custData.user_dial_code + custData.user_phone_number
                    let contactNum = custData.user_phone_number
                    this.props.onChangeValue({ target: { name: 'name', value: custData.user_full_name } }, 'customer_details')
                    this.props.onChangeValue({ target: { name: 'mobile_number', value: contactNum } }, 'customer_details')
                    this.props.onChangeValue({ target: { name: 'user_type', value: custData.user_type } }, 'customer_details')
                    this.props.onChangeValue({ target: { name: 'taxation_detail', value: custData.taxation_detail } }, 'customer_details')
                    this.props.onChangeValue({ target: { name: 'address', value: custData.address } }, 'customer_details')
                    this.props.onChangeValue({ target: { name: 'type', value: custData.type } }, 'customer_details')
                    this.props.onChangeValue({ target: { name: 'user_id', value: custData._id } },'customer_details')
                    this.props.onChangeValue({ target: { name: 'sales_person', value: custData?.sales_person } },'customer_details')
                }
            }
        });
    }

    onCountryChange = (e,name,) => {
        if (name === "shipper_country") {
            let findIso = this.state.country.find((item)=> item.name===e.value).isoCode
            this.setState({states:csc.getStatesOfCountry(findIso),countryCode: findIso})
        } else if (name === "shipper_state") {
          let findIso = this.state.states.find((item)=> item.name===e.value).isoCode
          this.setState({cities: csc.getCitiesOfState(this.state.countryCode, findIso)})
        }
        this.props.onChangeValue({target : {name:name,value:e.value}}, 'customer_details')
      };

      componentDidMount = () => {
        if(this.props?.jobData){
            this.getCountryStateCityLists(this.props.jobData)  
        }
      }

      getCountryStateCityLists = (data) => {
          if(data?.shipper_country && data?.shipper_state){
            let countryData = csc.getAllCountries().find((itm)=> itm.name===data.shipper_country)
            let allStates = csc.getStatesOfCountry(countryData?.isoCode)
            let statesData = allStates && allStates.find((itm)=> itm.name===data.shipper_state)
            if(countryData && allStates){
                this.setState({
                    countryCode : countryData?.isoCode,
                    states : allStates,
                    cities : csc.getCitiesOfState(countryData?.isoCode, statesData?.isoCode),
                })
            }
        }
    }

    render() {
        const { jobData, userData, formValidator } = this.props
        // console.log(jobData.email,'jobData.email')
                if (!jobData || Object.keys(jobData).length === 0) return false
        return (
            <div className="card">
                <div className="card-header bg-light"><h4>Customer /Commercial Information</h4></div>
                <div className="card-body">

                    <div className="row">
                        <div className="mb-3 col-md-6 col-12">
                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="email"
                                    value={jobData.email}
                                    onChange={(e) => this.props.onChangeValue(e, 'customer_details')}
                                    onKeyUp={(e) => this.checkUser(e)}
                                />
                                {
                                    formValidator.message('email', jobData.email, 'email', { className: 'text-danger' })
                                }
                            </div>


                            <div className="mb-3">
                                <label className="form-label">Number</label>
                                {/* <input 
                                    className="form-control form-control-sm"
                                    name="mobile_number"
                                    value={jobData.mobile_number}
                                    onChange={(e)=>this.props.onChangeValue(e, 'customer_details')}
                                /> */}

                            </div>

                            <PhoneInput
                                className="telinput"
                                country={"ae"}
                                value={jobData.mobile_number}
                                enableSearch
                                enableAreaCodes={true}
                                onChange={(phone, f, g) => this.props.onChangeValue({ value: phone }, 'customer_details', 'mobile_number')}
                            />

                            {
                                // formValidator.message('contact', jobData.mobile_number, 'phone|min:9', { className: 'text-danger' })
                            }

                        </div>

                        <div className="mb-3 col-md-6 col-12">

                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="name"
                                    value={jobData.name}
                                    onChange={(e) => this.props.onChangeValue(e, 'customer_details')}
                                />
                                {
                                    // formValidator.message('customer name', jobData.name, 'required', { className: 'text-danger' })
                                }
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Type</label>
                                <Select
                                    options={JobOptions.customerType()}
                                    name="user_type"
                                    value={JobOptions.customerType().filter(obj => obj.value === jobData.user_type)}
                                    onChange={(e) => this.props.onChangeValue(e, 'customer_details', 'user_type')}
                                />
                                {
                                    // formValidator.message('user type', jobData.user_type, 'required', { className: 'text-danger' })
                                }
                            </div>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                            <label className="form-label">Shipper</label>
                            <input
                                className="form-control form-control-sm"
                                name="sipper"
                                value={jobData.sipper}
                                onChange={(e) => this.props.onChangeValue(e, 'customer_details')}
                            />
                            {/* {
                                formValidator.message('email', jobData.email, 'email', { className: 'text-danger' })
                            } */}
                        </div>
                        <div className="col-12 col-md-6">
                                <label className="form-label">profile Type</label>
                                <Select
                                    options={JobOptions.userTypeList()}
                                    name="type"
                                    value={JobOptions.userTypeList().filter(obj => obj.value === jobData.type)}
                                    onChange={(e) => this.props.onChangeValue(e, 'customer_details', 'type')}
                                />
                                {
                                    // formValidator.message('user type', jobData.user_type, 'required', { className: 'text-danger' })
                                }
                            </div>
                                {/* country  */}
                            <div className="col-3">
                            <label className="form-label">Shipper Country </label>
                            <Select 
                                    name="shipper_country" 
                                    value={jobData.shipper_country && {label:jobData.shipper_country,value:jobData.shipper_country}}
                                    onChange={(e) => this.onCountryChange(e, "shipper_country")}
                                    options={helperFunction.convertToSelectList(this.state.country,"name","name")}
                                />
                                </div>
                                {/* state  */}
                                <div className="col-3">
                                <label className="form-label">Shipper State </label>
                                <Select 
                                    name="shipper_state" 
                                    value={jobData.shipper_state && {label:jobData.shipper_state,value:jobData.shipper_state}} 
                                    onChange={(e) => this.onCountryChange(e, 'shipper_state')}
                                    options={helperFunction.convertToSelectList(this.state.states,"name","name")}
                                    // <option value="">Select State</option>
                                    // {this.state.states.map((item1)=>{return (
                                    //     <option key={item1.name} value={item1.name}>{item1.name}</option>
                                    // )})}
                                />    
                                </div>

                                <div className="col-12 col-md-6">
                            <div className="">
                                <label className="form-label">Comment</label>
                                <textarea
                                    className="form-control form-control-sm"
                                    name="comments"
                                    value={jobData.comments}
                                    onChange={(e) => this.props.onChangeValue(e, 'customer_details')}
                                />
                            </div>

                        </div>

                        {/* city  */}
                    <div className="mb-2 col-3">
                    <label className="form-label">Shipper City</label>
                        <Select name="shipper_city" 
                            value={jobData.shipper_city && {label:jobData.shipper_city,value:jobData.shipper_city}}
                            onChange={(e) => this.onCountryChange(e, 'shipper_city')}
                            options={helperFunction.convertToSelectList(this.state.cities,"name","name")}
                        />        
                    </div>

                    {/* postal code  */}
                    <div className="mb-2 col-3">
                    <label className="form-label">Shipper Postal Code</label>
                    <input
                        type="text"
                        className={"form-control"}
                        name='shipper_postal_code'
                        value={jobData.shipper_postal_code}
                        onChange={(e) => this.props.onChangeValue(e, 'customer_details')}
                        placeholder="Enter Postal Code"
                    />
                    </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default Customerinfo